<template>
  <div>
    <div class="jm-white-container">
      <div class="col-lg-10 mx-auto">
        <div class="col-12">
          <article class="d-flex align-items-center justify-content-between">
            <div class="h5 mb-3 mr-3">
              Cinema: {{ currentCinemaIndex }}/{{ noOfCinemas }}
            </div>
            <!-- <FilterByStatusDropdown /> -->
          </article>
        </div>
        <div class="row">
          <!-- MULTIPLE LEVEL CHECKBOX -->
          <div
            class="col-12 d-flex justify-content-center align-items-center mb-4"
          >
            <div class="mr-2">
              Do you have multiple concession levels in cinema?
            </div>
            <!-- <label class="ios-switch">
              <input type="checkbox" class="ios-checkbox" v-model="multipleConcessionLevels" />
              <span class="switch-slider"></span>
            </label> -->
            <StatusDot
              :status="multipleConcessionLevels ? 'active' : 'inactive'"
            />
          </div>

          <div class="col-12 mb-4" v-if="multipleConcessionLevels">
            <div class="col-md-6 mx-auto px-0">
              <div class="input-container">
                <input
                  v-model="concessionLevel"
                  type="text"
                  name="concession_level"
                  id="concession_level"
                  placeholder="No of Levels"
                  v-validate="{ required: 'required' }"
                />
              </div>
              <p
                v-if="submitted && errors.has('concession_level')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"concession_level"}`) }}
              </p>
            </div>
          </div>

          <!-- NAVIGATIONS -->
          <div class="col-12 text-center">
            <router-link class="btn-outline-blue-lg w-25" to="add-seat-layout"
              >Back</router-link
            >
            <router-link
              class="btn-blue-lg w-25"
              to
              v-on:click.native="onProceed()"
              >Proceed</router-link
            >
            <!-- <router-link class="btn-blue-lg w-25" to="concession-counters">Proceed</router-link> -->
          </div>
        </div>

        <div class="col-md-12 mx-auto text-center mt-5"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SetupService from "@/services/SetupService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      submitted: false,
      multipleConcessionLevels: false,
      concessionLevel: null
    };
  },
  computed: {
    noOfCinemas() {
      return this.$store.getters.NO_OF_CINEMAS || 1;
    },
    currentCinemaIndex() {
      return this.$store.getters.currentCinemaIndex;
    }
  },
  methods: {
    onProceed: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          if (!this.multipleConcessionLevels) {
            this.$router.push({
              path: "concession-counters"
            });
            this.$store.dispatch("setConcessionLevelValue", 1);
          } else if (this.multipleConcessionLevels) {
            this.$store.dispatch(
              "setConcessionLevelValue",
              this.concessionLevel
            );

            let payload = {
              concessionLevel: this.concessionLevel
            };
            // console.log("payload.concessionLevel ", payload.concessionLevel);
            SetupService.addConcessionLevel(payload)
              .then(result => {
                const { data } = result;
                if (data.status) {
                  this.$router.push({ path: "concession-counters" });
                } else {
                  console.log("something wrong");
                }
              })
              .catch(err => {
                console.log("err :", err);
              });
          }
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/cinemaInstallation/cinemaConcessionLevels.vue